// import Dashboard from "views/Dashboard/Dashboard.jsx";
import Buttons from "views/Components/Buttons.jsx";

import LoginPage from "views/Pages/LoginPage.jsx";
import chooseTenant from "views/Pages/chooseTenant.jsx";
import Loading from "views/Pages/Loading.jsx";
import ContentLoader from "views/Pages/ContentLoader.jsx";
import Runs from "views/Runs/Runs.jsx";
import Storage from "views/Storage/Storage.jsx";

import StorageView from "views/Storage/StorageView.jsx";
import Clusters from "views/Clusters/Clusters.jsx";
import all from "views/Clusters/all.jsx";
import Create from "views/Clusters/Create.jsx";
import ViewCluster from "views/Clusters/ViewCluster.jsx";
// import Providers from "views/Clusters/Providers.jsx";
// import CreateProviders from "views/Clusters/CreateProviders.jsx";

import Project from "views/Projects/Project.jsx";
import NewProject from "views/Projects/NewProject.jsx";
import ViewProject from "views/Projects/ViewProject.jsx";
import Profile from "views/Profile/Profile.jsx";
import ChangePassword from "views/Profile/ChangePassword.jsx";
import UpdatePassword from "views/Profile/UpdatePassword.jsx";
import ForgotPassword from "views/Profile/ForgotPassword.jsx";
import UserManagement from "views/UserManagement/UserManagement.jsx";
import AdminManagement from "views/SuperAdmin/AdminManagement.jsx";
import NewAccount from "views/SuperAdmin/NewAccount.jsx";
import NewUser from "views/UserManagement/NewUser.jsx";
import OAuth2RedirectHandler from './services/oauth2/OAuth2RedirectHandler';
import Job from "views/Runs/Job.jsx";
import Chat from "views/Chat/Chat.jsx";
import Integration from "views/Integration/Integration.jsx";
import NewConnection from "views/Integration/NewConnection.jsx";
import ChooseConnector from "views/Integration/ChooseConnector";
import ShowConnector from "views/Integration/ShowConnector.jsx";
import NewModel from "views/ModelSpace/NewModel.jsx";
import Connectors from "views/Integration/Connectors";
import CreateConnection from "views/Integration/CreateConnection";
import Provisioner from "views/Cloud/Provisioner.jsx"
import NewProvisioner from "views/Cloud/NewProvisioner.jsx";
import machinetype from "views/Cloud/MachineType.jsx"
import newmachinetype from "views/Cloud/NewMachineType";
import imagemapping from "views/Cloud/ImageMapping.jsx"
import newimagemapping from "views/Cloud/NewImageMapping.jsx"
import Analyze from "views/Analyze/Analyze.jsx"
import SchedulerList from "views/Scheduler/SchedulerList";
import SchedulerRunDetails from "views/Scheduler/SchedulerRunDetails";
import MailEventHandler from "views/Profile/MailEventHandler.jsx";
import CustomMenu from "views/Settings/CustomMenu";
import SettingsLoader from "views/Settings/SettingsLoader";
import NetworkStatus from "views/Pages/NetworkStatus";
let routes = [
 
  {
    path: "/login-page",
    name: "Login Page",
    short: "Login",
    mini: "LP",
    component: LoginPage,
    layout: "/auth",    
    module:"login",
    display:"none",

  },
  {
    path: "/tenants",
    name: "Choose Tenant",
    component: chooseTenant,
    layout: "/auth",    
    module:"chooseTenant",
    display:"none",

  },
  {
    path: "project",
    name: "Projects",
    icon: "now-ui-icons design_app",
    component: Project,
    layout: "/",
    module:"projects",
    display:"true",
  },
  {
    path: "accounts",
    name: "Accounts",
    icon: "fas fa-users-cog",
    component: AdminManagement,
    layout: "/",
    module:"superadmin",
    display:"true",
  },
  {
        collapse: true,
        name: "Platform",
        icon:"fas fa-cloud",
        layout: "/",
        state: "openCloud",
        module:"cloud",
        display:"true",     
        views:[
          {
          collapse: true,
          name: "Compute",
          icon:"fas fa-tachometer-alt",
          layout: "/",
          state: "openCompute",
          module:"Compute",
          display:"true",     
          views:[
            {
              path: "cluster/all",
              name: "Cluster",
              icon:"fas fa-dharmachakra",
              component: all,
              layout: "/",
              module:"all",
              display:"true",
             
            },
            {
              path:"cloud/machinetype",
              name: "Machine Type",
              mini: "MT",
              icon: "fas fa-cog",
              component: machinetype,
              layout: "/",
              module:"machinetype",
              display:"true", 
            },
            {
              path: "cloud/imagemapping",
              name: "Cloud Images",
              icon: "fas fas fa-images",
              component: imagemapping,
              layout: "/",
              module:"imagemapping",
              display:"true",
            },
          ]
        },
        {
          path:"cloud/Provisioner",
          name: "Provisioners",
          mini: "Pr",
          icon: "fas fa-layer-group",
          component: Provisioner,
          layout: "/",
          module:"provisioner",
          display:"true",
         
        },
        ]
      
  },
 
  {
    path: "newaccount",
    name: "New Account",
    icon: "now-ui-icons design_app",
    component: NewAccount,
    layout: "/",
    display:"none",
    module:"NewAccount",
  },
  {
    path: "runs",
    name: "Runs",
    icon: "fas fa-running",
    component: Runs,
    layout: "/",
    module:"runs",
    display:"true",
  },

  {
  path: "chat",
  name: "Chat",
  icon: "fas fa-comments",
  component: Chat,
  layout: "/",
  display:"true",
  module:"Chat",
  },
  {
    path: "storage",
    name: "Storage",
    icon: "fas fa-database",
    component: Storage,
    layout: "/",
    module:"storage",
    display:"true",
  },
  {
    path: "analyze",
    name: "Compare",
    icon: "fas fa-chart-bar",
    component: Analyze,
    layout: "/",
    module:"analyze",
    display:"none",
  },
  // {
  //   path: "notebook",
  //   name: "Notebook",
  //   icon: "far fa-sticky-note",
  //   layout: "/",
  //   module:"Notebook",
  //   display:"true",
  // },
  {
    path: "cluster/all",
    name: "Clusters",
    icon:"fas fa-dharmachakra",
    component: all,
    layout: "/",
    module:"all",
    display:"true",
   
  },
  {
    path: "modelspace",
    name: "Model Space",
    icon: "fas fa-columns",
    component: NewModel,
    layout: "/",
    module:"newmodel",
    display:"true",
  },
  {
    path: "schedule",
    name: "Schedule",
    icon: "far fa-calendar-alt",
    component: SchedulerList,
    layout: "/",
    module:"Schedule",
    display:"true",
  },
  {
    collapse: true,
    name: "Admin",
    state: "openAdmin",
    icon: "fas fa-users-cog",
    views: [
      {
        collapse: true,
        name: "Cloud",
        icon:"fas fa-cloud",
        component: Clusters,
        layout: "/",
        state: "openCloud",
        module:"cloud",
        display:"true",
        views: [
          {
            path: "cluster/all",
            name: "Cluster",
            icon: "fas fa-dharmachakra",
            component: all,
            layout: "/",
            module:"clusters",
            display:"true"
          },
          {
            path:"cloud/Provisioner",
            name: "Provisioners",
            icon: "fas fa-layer-group",
            component: Provisioner,
            layout: "/",
            module:"provisioner",
            display:"true",
           
          },
          {
            path:"cloud/machinetype",
            name: "Machine Type",
            mini: "MT",
            icon: "fas fa-cog",
            component: machinetype,
            layout: "/",
            module:"machinetype",
            display:"true"
          }
        ]
      },
      {
        collapse: true,
        name: "User Management",
        icon: "fas fa-user-cog",
        layout: "/admin",
        state: "openUserManagement",
        display:"true",
         module:"UserManagements",
         views: [
          {
            path: "/usermanagement",
            name: "Show Users",            
            mini: "Su",
            icon: "fas fa-user-edit",
            component: UserManagement,
            layout: "/admin",
            module:"UserManagement",
            display:"true",
           
          }
        ]
      },
      {
        collapse: true,
        name: "Integration",
        path: "/integration",
        icon: "fas fa-link",
        component: Integration,
        layout: "/",
        state: "openIntegration",
        module:"integration",
        display:"true",
        views: [
          {
            path:"integration/connectors",
            name: "Connectors",
            icon: "fas fa-plug",
            mini: "Co",
            component: Connectors,
            layout: "/",
            module:"cloud",
            display:"true",
           
          }
        ]
      },
    ]
  },
  // {
  //   collapse: true,
  //   // path: "/components",
  //   name: "Billing",
  //   state: "openBilling",
  //   icon: "fas fa-file-invoice-dollar",
  //   display:"true",
  //   views: [
  //     {
  //       // path: "/buttons",
  //       name: "Payment",
  //       icon: "far fa-credit-card",
  //       component: Buttons,
  //       mini: "Su",
  //       layout: "/admin",
  //       module:"payment",
  //       display:"true",
  //     },
  
  //   ]
  // },
  {
    collapse: true,
    name: "Settings",
    state: "openSettings",
    icon: "fas fa-cog",
    display:"true",
    views: [
      {
        // path: "/buttons",
        path:"settings/custommenu",
        name: "Custom Menu",
        icon: "fas fa-layer-group",
        component: CustomMenu,
        mini: "CM",
        layout: "/",
        module:"custommenu",
        display:"true",
      },
  
    ]
  },
  
  {
    path: "newProject",
    component: NewProject,
    layout: "/",
    display:"none",
    module:"newprojects",
 },
 {
    path: "viewProject",
    name: "View Project",
    icon: "now-ui-icons design_app",
    component: ViewProject,
    layout: "/",
    display:"none",
    module:"viewProject",
 },
 {
  path: "/profile",
  name: "Profile",
  icon: "now-ui-icons design_app",
  component: Profile,
  layout: "/admin",
  display:"none",
  module:"Profile",
},
{
  path: "/changepassword",
  name: "Change Password",
  icon: "now-ui-icons design_app",
  component: ChangePassword,
  layout: "/admin",
  display:"none",
  module:"ChangePassword",
},
{
  path: "/updatepassword",
  name: "Update Password",
  icon: "now-ui-icons design_app",
  component: UpdatePassword,
  layout: "/auth",
  display:"none",
  module:"UpdatePassword",
},

{
  path: "/forgotpassword/reset/password",
  name: "Mail Handler",
  icon: "now-ui-icons design_app",
  component: MailEventHandler,
  layout: "/auth",
  display:"none",
  module:"MailEventHandler",
},

{
  path: "/signup/verify",
  name: "Mail Handler",
  icon: "now-ui-icons design_app",
  component: MailEventHandler,
  layout: "/auth",
  display:"none",
  module:"MailEventHandler",
},

{
  path: "/forgotpassword",
  name: "Forgot Password",
  icon: "now-ui-icons design_app",
  component: ForgotPassword,
  layout: "/auth",
  display:"none",
  module:"ForgotPassword",
},

{
  path: "/newuser",
  name: "New User",
  icon: "now-ui-icons design_app",
  component: NewUser,
  layout: "/admin",
  display:"none",
  module:"NewUser",
},
{
  path: "cluster/Create",
  name: "New Clusters",
  icon: "now-ui-icons design_app",
  component: Create,
  layout: "/",
  display:"none",
  module:"Create",
},
{
  path: "cluster/viewcluster",
  name: "ViewCluster",
  icon: "now-ui-icons design_app",
  component: ViewCluster,
  layout: "/",
  display:"none",
  module:"ViewCluster",
},
{
  path: "storageView",
  name: "Storage View",
  icon: "now-ui-icons design_app",
  component: StorageView,
  layout: "/",
  display:"none",
  module:"StorageView",
},
{
  path: "/oauth2/redirect",
  component: OAuth2RedirectHandler,
  layout: "/admin",
  display:"none",

},
{
  path: "job",
  name: "Job",
  icon: "now-ui-icons design_app",
  component: Job,
  layout: "/",
  display:"none",
  module:"Job",
},
{
  path: "viewScheduler",
  name: "SchedulerRunDetails",
  icon: "now-ui-icons design_app",
  component: SchedulerRunDetails,
  layout: "/",
  display:"none",
  module:"SchedulerRunDetails",
},
{
  path: "/loading",
  name: "Loading",
  icon: "now-ui-icons design_app",
  component: Loading,
  layout: "/auth",
  display:"none",
  module:"Loading",
},
{
  path: "/content-loader",
  name: "ContentLoader",
  icon: "now-ui-icons design_app",
  component: ContentLoader,
  layout: "/auth",
  display:"none",
  module:"ContentLoader",
},
{
  path: "/menu-settings",
  name: "menuSettings",
  icon: "now-ui-icons design_app",
  component: SettingsLoader,
  layout: "/auth",
  display:"none",
  module:"menuSettings",
},
{
  path: "/offline",
  name: "networkStatus",
  icon: "now-ui-icons design_app",
  component: NetworkStatus,
  layout: "/auth",
  display:"none",
  module:"networkStatus",
},
{
  path: "integration/NewConnection",
  component: NewConnection,
  layout: "/",
  display:"none",
  module:"NewConnection",
},
{
  path: "connectors/ChooseConnector",
  component: ChooseConnector,
  layout: "/",
  display:"none",
  module:"ChooseConnector",
 
},
{
  path: "cloud/NewProvisioner",
  component: NewProvisioner,
  layout: "/",
  display:"none",
  module:"NewProvisioner",
},
{
  path: "integration/ShowConnector",
  component: ShowConnector,
  layout: "/",
  display:"none",
  module:"ShowConnector",
},
{
  path:"integration/CreateConnection",
  component: CreateConnection,
  layout: "/",
  module:"CreateConnection",
  display:"none",
 
},

{
  path:"cloud/newmachinetype",
  name: "New Machine Type",
  icon: "fas fa-cog",
  component: newmachinetype,
  layout: "/",
  module:"newmachinetype",
  display:"none"
},
{
  path:"cloud/newimagemapping",
  name: "New Image Mapping",
  icon: "fas fa-cog",
  component: newimagemapping,
  layout: "/",
  module:"newimagemapping",
  display:"none"

}

];

export default routes;
